<template>
    <div class="Jur-Cadastro-Principal">
        <PageTitle icon="fa fa-group" main="Cadastro"
            sub="Cadastro -> Escritório / Advogados" />
        <div class="Jur-Cadastro-Principal">
            <b-card no-body>
                <b-tabs>                    
                    <b-tab title="Auditoria" active><AuditoriaApps /></b-tab>                    
                    <b-tab title="Ultimo acesso" ><UltimoAcesso /></b-tab>                    
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import AuditoriaApps from '../informatica/InformaticaAuditoriaApp'
import UltimoAcesso from '../informatica/InformaticaAppUltimoAcesso'



export default {
    name: 'JuridicoPrincipalAuditoria',    
    components: { PageTitle, AuditoriaApps,UltimoAcesso }
    
}
</script>

<style>

</style>






